var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "basket-preview-wrapper h-100",
      class: {
        empty: !_vm.basketItems.length,
        "open-hover": _vm.hover,
        "open-right": !_vm.hover,
      },
    },
    [
      _c("div", { staticClass: "position-relative h-100" }, [
        _c(
          "div",
          {
            staticClass:
              "basket-preview d-flex flex-column flex-nowrap bg-white shadow w-100",
          },
          [
            _c(
              "header",
              { staticClass: "basket-preview-header border-bottom p-3" },
              [
                _c("span", { staticClass: "h3 mb-0" }, [
                  _vm._v(
                    _vm._s(_vm.$translate("Ceres::Template.basketPreview"))
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "toggle-basket-preview",
                        rawName: "v-toggle-basket-preview",
                      },
                    ],
                    staticClass: "close",
                    attrs: {
                      type: "button",
                      "aria-label": _vm.$translate("Ceres::Template.closeIcon"),
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "24",
                          height: "24",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "#f9f9f9",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      },
                      [
                        _c("line", {
                          attrs: { x1: "18", y1: "6", x2: "6", y2: "18" },
                        }),
                        _vm._v(" "),
                        _c("line", {
                          attrs: { x1: "6", y1: "6", x2: "18", y2: "18" },
                        }),
                      ]
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _vm.basketNotifications.length > 0
              ? _c(
                  "div",
                  _vm._l(_vm.basketNotifications, function (notification) {
                    return _c(
                      "div",
                      {
                        key: notification.id,
                        staticClass: "w-100 alert alert-danger",
                      },
                      [_c("div", [_vm._v(_vm._s(notification.message))])]
                    )
                  }),
                  0
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "basket-preview-content d-flex flex-fill" },
              [
                _c("basket-list", {
                  staticClass:
                    "item-list d-flex flex-fill flex-nowrap flex-column overflow-auto px-3",
                  attrs: { "is-preview": true },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "before-basket-item",
                        fn: function () {
                          return [_vm._t("before-basket-item")]
                        },
                        proxy: true,
                      },
                      {
                        key: "after-basket-item",
                        fn: function () {
                          return [_vm._t("after-basket-item")]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "totals d-flex flex-nowrap flex-column px-3 pt-3",
                  },
                  [
                    _vm.showShippingCountrySelect
                      ? _c("shipping-country-select", {
                          attrs: {
                            "basket-select": true,
                            "open-basket-preview": true,
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _vm._t("before-basket-totals"),
                    _vm._v(" "),
                    _c("basket-totals", {
                      attrs: { "visible-fields": _vm.visibleFields },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "before-item-sum",
                            fn: function () {
                              return [_vm._t("before-item-sum")]
                            },
                            proxy: true,
                          },
                          {
                            key: "after-item-sum",
                            fn: function () {
                              return [_vm._t("after-item-sum")]
                            },
                            proxy: true,
                          },
                          {
                            key: "before-shipping-costs",
                            fn: function () {
                              return [_vm._t("before-shipping-costs")]
                            },
                            proxy: true,
                          },
                          {
                            key: "after-shipping-costs",
                            fn: function () {
                              return [_vm._t("after-shipping-costs")]
                            },
                            proxy: true,
                          },
                          {
                            key: "before-total-sum",
                            fn: function () {
                              return [_vm._t("before-total-sum")]
                            },
                            proxy: true,
                          },
                          {
                            key: "before-vat",
                            fn: function () {
                              return [_vm._t("before-vat")]
                            },
                            proxy: true,
                          },
                          {
                            key: "after-vat",
                            fn: function () {
                              return [_vm._t("after-vat")]
                            },
                            proxy: true,
                          },
                          {
                            key: "after-total-sum",
                            fn: function () {
                              return [_vm._t("after-total-sum")]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _vm._v(" "),
                    _vm._t("after-basket-totals"),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "basket-preview-footer pb-3" },
                      [
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "waiting-animation-infinite",
                                rawName: "v-waiting-animation-infinite",
                              },
                            ],
                            staticClass:
                              "btn btn-outline-dark btn-lg btn-block",
                            attrs: {
                              href: _vm.$ceres.urls.basket,
                              rel: "nofollow",
                              title: _vm.$translate("Ceres::Template.basket"),
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$translate("Ceres::Template.basket")
                                ) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm._t("before-checkout-button"),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "waiting-animation-infinite",
                                rawName: "v-waiting-animation-infinite",
                              },
                            ],
                            staticClass:
                              "btn btn-secondary btn-lg btn-block ml-0",
                            attrs: {
                              href: _vm.$ceres.urls.checkout,
                              rel: "nofollow",
                              title: _vm.$translate(
                                "Ceres::Template.basketCheckout"
                              ),
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.basketCheckout"
                                  )
                                ) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm._t("after-checkout-button"),
                      ],
                      2
                    ),
                  ],
                  2
                ),
              ],
              1
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", {
        directives: [
          { name: "toggle-basket-preview", rawName: "v-toggle-basket-preview" },
        ],
        staticClass: "basket-preview-overlay",
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }